import styled from "styled-components";

export const Wrapper = styled.div`
  padding-top: 48px;
  font-size: 0.9rem;
`;

export const LabelButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Label = styled.label`
  font-weight: bold;
  font-size: 1rem;
  color: ${(p) => (p.error ? p.theme.colors[p.error] : p.theme.colors.primary)};
`;

export const Buttons = styled.div`
  margin-bottom: 8px;
  display: flex;
  justify-content: flex-end;
`;

export const Button = styled.button`
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 16px;
  font-size: 0.8rem;

  &:last-child {
    margin-left: 4px;
  }
`;

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
`;

export const THead = styled.thead``;

export const TBody = styled.tbody``;

export const TR = styled.tr``;

export const TH = styled.th`
  padding: 0;
  border: 1px solid #ddd;
  hyphens: auto;

  ${(p) =>
    p.isHidden &&
    `
    background: rgba(255, 255, 255, 0.5);
  `}
`;

export const TD = styled.td`
  padding: 0;
  border: 1px solid #ddd;

  ${(p) =>
    p.isHidden &&
    `
    background: rgba(255, 255, 255, 0.5);
  `}
`;

export const CellWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const CellName = styled.div``;

export const ColName = styled.span`
  margin-right: 4px;
  color: #777;
`;

export const CellOptionsWrapper = styled.div`
  position: absolute;
  right: 4px;
`;

export const CellButton = styled.button`
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eee;
  border: 1px solid #ddd;
  color: #777;
  font-size: 0.8rem;

  &:focus {
    outline: none;
    background: #ddd;
  }
`;

export const CellIcon = styled.em``;

export const CellDropDown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  ${(p) => (p.right ? "left: 0" : "right: 0")};
  background: #fff;
  font-size: 0.8rem;
  font-weight: normal;
  border-radius: 4px;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  z-index: 100;
`;

export const CellDropDownItems = styled.ul`
  margin: 0;
  padding: 4px;
  list-style-type: none;
`;

export const CellDropDownItem = styled.li`
  padding: 4px 8px;
  white-space: nowrap;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.right ? "flex-start" : "flex-end")};

  &:hover {
    background: #f5f5f5;
  }

  & > em {
    width: 15px;
    text-align: center;
    color: #777;
  }
`;

export const CellInput = styled.input`
  padding: 8px;
  width: 100%;
  border: none;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 1px #000;
  }
`;

export const CellValue = styled.div`
  padding: 8px;

  ${(p) =>
    p.isHidden &&
    `
    color: #aaa;
  `}

  ${(p) =>
    p.cellNumber &&
    `
    color: #777;
    font-weight: bold;
  `}
`;
